import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";


@Component({
  selector: 'sm-add-tracking-items',
  templateUrl: './add-tracking-items.component.html',
  styleUrls: ['./add-tracking-items.component.scss']
})
export class AddTrackingItemsComponent implements OnInit, OnDestroy {
  trackingName: any;
  measurementUnit: any;
  apisub: Subscription
    currentValue: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<AddTrackingItemsComponent>
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_TRACKER){
        if(resdata.result){
          this.activemodal.close({msg:'success'});
        }
      }
    })
  }

  ngOnInit(): void {}
  trackingStatus: boolean = false;

  onSave() {
    let obj = {
      // hash_id: "9c1b238e5c63dca1f8b47dc6781309150f539c82",
      member_hash: this.parentdata.memberHash,
      tracking_item_name: this.trackingName,
      measurement_unit: this.measurementUnit,
      status: 1,
      creation_time: this.formatDateString1(new Date()),
      creator_type: 2,
      created_by: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
       current_value: this.currentValue,
      tracking_enabled: this.trackingStatus ? 1 : 0 
    };

    Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null || (obj as any)[key] === '' || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });
    console.log(obj);
    this.ls.showLoader = true;
    this.apiservice.addEditProgressTracker(obj)
  }

  typenumber: boolean = false
  onchange(event:any){
    if(event.checked){
     if (this.currentValue) {
      // keep only digits and dots
      let sanitized = this.currentValue.replace(/[^0-9.]/g, '');

      // allow only the first dot
      const firstDotIndex = sanitized.indexOf('.');
      if (firstDotIndex !== -1) {
        // remove extra dots
        sanitized =
          sanitized.substring(0, firstDotIndex + 1) +
          sanitized
            .substring(firstDotIndex + 1)
            .replace(/\./g, '');
      }

      this.currentValue = sanitized;
    }
      this.typenumber = true
    }else if(!event.checked){
      this.typenumber = false
    }
  }

  formatDateString1(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day}`;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
